import type { SVGProps } from 'react';

export function FeatherIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M48 14C50 28 42 42 28 46L18 50L22 40C26 28 36 18 48 14Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
        fill="none"
      />
      <path d="M18 50L8 60" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M28 32L34 38" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M32 26L40 34" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M38 22L46 30" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
